module.exports = __webpack_public_path__ + "static/media/targeted.74bdf7bc.svg";